// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__13LSU","active":"Uploader_active__3DCn2"};